import axiosClient from "./axiosClient";
import urlApi from "./url";

const synchronizeApi = {
  updatePSIDCustomer: (params) => {
    return axiosClient.post(urlApi.synchronizeApi.updatePSIDCustomer, params);
  },
  syncPancakeToBombot: (params) => {
    return axiosClient.post(urlApi.synchronizeApi.syncPancakeToBombot, params);
  },
  getHistorySync: (params) => {
    return axiosClient.get(urlApi.synchronizeApi.getHistorySync, {params});
  },
  getStatisticSync: (params) => {
    return axiosClient.get(urlApi.synchronizeApi.getStatisticSync, {params});
  }
};

export default synchronizeApi;